export const chartColors = {
    green: "#009595",
    red: "#FF4C51",
    pink: "#d397ff",
    cyan: "#73C5C5",
    gold: "#F4C145",
    blue: "#16B1FF",
    orange: "#EF9234",
    purple: "#5752D1",
    lightPurple: "#8481DD",
    gray: "#B8BBBE",
    lightGray: "#F0F0F0",
}


